/**
 * Shared display label for a part's published conformity result.
 *
 * Historia 97 (#2849), bloque D. RN8.1/INV6: the label is chosen purely from the `result` value
 * received from Sun (`'OK'` | `'NOK'` | anything else, including a missing/empty field) — never
 * from the row's `status`. A part without a published result renders empty (P3): "no aplica",
 * never a NOK or any other substitute text (S33).
 *
 * S40: these are dedicated keys for the part's conformity result, kept apart from the generic
 * `OK`/`NOK` keys (used elsewhere as confirmation-button labels, e.g. `JobControls.jsx`) so the
 * two senses can be translated independently. Deliberately not "key === English value" (unlike
 * most keys in this repo): the industry-standard OK/NOK quality mark stays short and identical
 * across all 8 locales (same reasoning that already left the generic `NOK` key untranslated in
 * 7 of 8 locales), while the *key* itself stays unambiguous for future maintainers.
 */
import { systemValueLabel } from '../systemValues/systemValueLabel'

const PART_RESULT_OK_KEY = 'Part result OK'
const PART_RESULT_NOK_KEY = 'Part result NOK'

const PART_RESULT_OK = 'OK'
const PART_RESULT_NOK = 'NOK'

/**
 * @param {string} result The part's published result field, as Sun sends it.
 * @param {function(string): string} t_ Translation function from useSmartTranslation().
 * @returns {string} The localized label, or '' when there is no published result.
 */
// Story 204 (RN1.5, P1-bis): OK/NOK keep their own keys (the generic OK/NOK are button labels), so the map stays whole.
const PART_RESULT_KEYS = { [PART_RESULT_OK]: PART_RESULT_OK_KEY, [PART_RESULT_NOK]: PART_RESULT_NOK_KEY }

const partResultLabel = (result, t_) =>
  (result === PART_RESULT_OK || result === PART_RESULT_NOK) ? systemValueLabel(t_, 'PartResult', result, PART_RESULT_KEYS) : ''

export {
  PART_RESULT_OK,
  PART_RESULT_NOK,
  PART_RESULT_OK_KEY,
  PART_RESULT_NOK_KEY,
  partResultLabel
}
